function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -761.0247,
    y1: 3902.8079,
    x2: -3135.6411,
    y2: 953.6831,
    gradientTransform: "matrix(0.4648 -0.8854 0.8854 0.4648 1384.8185 -1195.0485)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M3153.245,1330.588c25.491,74.982,34.291,137.888,41.244,187.589 c81.728,584.223-270.63,1039.787-348.328,1135.131c-114.735,140.793-336.516,412.944-711.127,497.228 c-566.755,127.516-1156.858-248.43-1428.7-720.804c-49.725-86.405-332.358-553.306-132.269-1095.699 c121.092-328.251,390.035-643.805,743.393-789.068C2059.188,240.044,2960.073,762.371,3153.245,1330.588z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163070280329501005820000015865710037978299787_",
    gradientUnits: "userSpaceOnUse",
    x1: 1404.455,
    y1: 1989.1793,
    x2: 3612.7732,
    y2: 472.545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163070280329501005820000015865710037978299787_)"
    },
    d: "M726.449,888.908 c16.553-15.5,38.931-23.207,61.522-21.176c241.647,21.732,692.494-94.666,987.152-396.155 c20.461-20.935,57.754-9.103,81.208,8.423c327.699,244.92,870.9,295.64,1059.468,306.009 c39.004,2.147,70.653,32.404,74.683,71.264c171.487,1656.272-906.899,2256.446-1130.558,2362.386 c-24.448,11.583-53.232,9.901-76.199-4.401C669.021,2520.926,716.703,1617.965,701.286,948.916 C700.764,926.242,709.896,904.412,726.449,888.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1829.768,3098.881c-4.896,0-9.786-1.374-14.041-4.094 c-427.262-273.125-705.733-599.64-851.322-998.205c-130.035-355.997-136.402-718.518-142.021-1038.365l-0.761-42.642 c-0.127-6.985,2.494-13.573,7.385-18.554c4.934-5.027,11.554-7.795,18.636-7.795c0.002,0,0.002,0,0.003,0 c140.344,0,306.301-32.604,467.522-91.806c184.658-67.808,352.728-166.789,486.04-286.24c8.791-7.876,21.803-8.817,31.64-2.29 c137.445,91.2,452.817,250.447,1020.696,292.302c12.731,0.939,22.784,10.868,23.902,23.61 c56.635,646.136-77.753,1192.505-399.43,1623.93c-240.247,322.211-525.12,490.084-636.446,547.304l-2.262-4.402l2.262,4.402 C1837.874,3097.94,1833.819,3098.881,1829.768,3098.881z M847.864,999.126c-4.624,0-8.734,1.717-11.794,4.832 c-3.013,3.069-4.628,7.13-4.549,11.436l0.761,42.65c5.602,319.067,11.954,680.705,141.419,1035.142 c144.819,396.45,421.992,721.349,847.357,993.26c4.815,3.081,10.939,3.382,15.989,0.789l0,0 c110.713-56.904,394.024-223.867,633.033-544.417c320.183-429.418,453.923-973.506,397.505-1617.151 c-0.691-7.881-6.901-14.021-14.767-14.601c-115.284-8.496-292.148-28.031-480.049-72.842 c-219.807-52.42-403.302-126.803-545.393-221.084c-6.082-4.035-14.125-3.456-19.562,1.414 c-134.234,120.279-303.407,219.923-489.233,288.16c-162.284,59.593-329.455,92.412-470.714,92.412 C847.867,999.126,847.866,999.126,847.864,999.126z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126285569218970069730000014413763774354168718_",
    gradientUnits: "userSpaceOnUse",
    x1: 8224.2295,
    y1: 3058.9766,
    x2: 7454.3198,
    y2: 3896.4226,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126285569218970069730000014413763774354168718_)"
    },
    d: "M1882.18,3121.361 c0,0-7.974,45.139-11.882,89.822c-1.528,17.462,11.934,32.624,29.45,33.355c59.504,2.477,186.785,7.296,232.457,5.258 c6.866-0.306,11.355-7.335,8.815-13.721l0,0c-2.131-5.351-6.237-9.678-11.47-12.082l-210.244-96.628L1882.18,3121.361z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056386809439056320060000004818180564171180221_",
    gradientUnits: "userSpaceOnUse",
    x1: 7974.3281,
    y1: 3121.1743,
    x2: 8042.7153,
    y2: 3121.1743,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056386809439056320060000004818180564171180221_)"
    },
    d: "M1875.648,3094.839l6.406,53.991 c0,0,36.83,17.145,61.981-2.161l-15.252-60.17L1875.648,3094.839z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057141859659091819100000017253031957536344459_",
    gradientUnits: "userSpaceOnUse",
    x1: 8284.8516,
    y1: 2111.9141,
    x2: 7629.7319,
    y2: 2999.844,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057141859659091819100000017253031957536344459_)"
    },
    d: "M1880.463,2079.777 c-2.768,14.099-14.852,703.605,58.85,1012.595c1.203,5.042-1.354,10.238-6.152,12.199 c-11.303,4.619-33.465,11.307-60.024,12.199c-8.225,0.276-15.599-5.069-17.92-12.965 c-21.068-71.69-122.02-430.881-135.191-774.004c-14.715-383.407,0-13.055,0-13.055l8.631-236.999L1880.463,2079.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001654163991530421170000011787355727018115235_",
    gradientUnits: "userSpaceOnUse",
    x1: 8051.5107,
    y1: 2900.1907,
    x2: 7281.6055,
    y2: 3737.6321,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001654163991530421170000011787355727018115235_)"
    },
    d: "M1640.329,3144.909 c0,0-12.692,22.788-24.981,83.34c-2.218,10.936,5.423,21.402,16.528,22.493c19.648,1.932,49.895,4.417,74.124,4.25 c11.17-0.076,19.886-9.802,18.54-20.89c-2.683-22.102-11.045-58.364-36.874-86.627L1640.329,3144.909z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011749318139100657970000015674973479218175676_",
    gradientUnits: "userSpaceOnUse",
    x1: 7727.8613,
    y1: 3117.668,
    x2: 7786.9072,
    y2: 3117.668,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011749318139100657970000015674973479218175676_)"
    },
    d: "M1629.181,3075.464l14.969,81.649 c0,0,14.801,11.01,44.078,3.029l-7.144-87.85L1629.181,3075.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106111133790310945350000015614439046823079852_",
    gradientUnits: "userSpaceOnUse",
    x1: 8168.0933,
    y1: 2025.7693,
    x2: 7512.9746,
    y2: 2913.6987,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106111133790310945350000015614439046823079852_)"
    },
    d: "M1588.745,2100.935 c-60.279,363.79,13.075,899.135,37.815,1003.914c1.514,6.415,6.692,11.33,13.194,12.407c11.043,1.831,29.224,3.324,47.148-1.882 c6.175-1.793,10.513-7.363,10.766-13.791c3.319-84.711-2.655-604.757,53.512-810.282c2.846-10.416,9.206-19.499,18.007-25.756 l109.015-77.5l8.357-125.272L1588.745,2100.935z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179616912660166578820000018318219123695489164_",
    gradientUnits: "userSpaceOnUse",
    x1: 1706.7092,
    y1: 1454.8792,
    x2: 2276.4692,
    y2: 2513.8884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179616912660166578820000018318219123695489164_)"
    },
    d: "M1972.844,1411.626 c-180.645-2.984-379.966,47.431-379.966,47.431c-53.847,314.193-9.417,676.593-9.417,676.593 c139.85,36.675,297.611-22.422,297.611-22.422c23.244-131.326,131.695-500.918,131.695-500.918 c88.263-10.953,160.972-36.42,220.848-70.087c-45.673-52.941-67.204-120.306-76.555-160.127 C2093.191,1401.945,2028.563,1412.547,1972.844,1411.626z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071551073605267119350000008633832410112352657_",
    gradientUnits: "userSpaceOnUse",
    x1: -3575.9617,
    y1: 929.9769,
    x2: -3455.3015,
    y2: 1274.7209,
    gradientTransform: "matrix(-1 0 0 1 -1123.3977 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071551073605267119350000008633832410112352657_)"
    },
    d: "M2506.438,1145.545 c-17.746-21.433-40.205-11.294-40.205-11.294c-26.583,112.292-165.971,203.34-309.172,247.844 c9.351,39.822,30.883,107.186,76.555,160.127C2471.272,1408.6,2506.438,1145.545,2506.438,1145.545z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072266787164189583670000013445300636322727343_",
    gradientUnits: "userSpaceOnUse",
    x1: 1486.2576,
    y1: 1573.485,
    x2: 2056.0183,
    y2: 2632.4956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072266787164189583670000013445300636322727343_)"
    },
    d: "M1662.167,1633.975l-69.288-174.918 c0,0-168.733,114.646-196.483,260.006c31.882,2.348,89.897,10.641,146.683,39.314 C1555.558,1689.74,1662.167,1633.975,1662.167,1633.975z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167393980258467256030000007125391502623604642_",
    gradientUnits: "userSpaceOnUse",
    x1: 7830.7329,
    y1: 1359.2483,
    x2: 8005.54,
    y2: 1359.2483,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167393980258467256030000007125391502623604642_)"
    },
    d: "M1789.866,1264.97l-57.479,166.225 c-0.951,2.753,0.18,5.803,2.73,7.213c15.668,8.663,72.117,33.702,140.143-9.428c7.086-4.493,11.911-11.82,12.986-20.143 l18.613-143.866H1789.866z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158748586561795663280000013875408208174091403_",
    gradientUnits: "userSpaceOnUse",
    x1: 813.051,
    y1: 3475.3645,
    x2: 747.7273,
    y2: 3259.9114,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 -972.3445 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158748586561795663280000013875408208174091403_)"
    },
    d: "M1914.931,1111.042 c0,0,63.117,118.812,55.028,166.806c-8.091,47.993-86.315,44.547-154.623,5.568l-47.732-128.289L1914.931,1111.042z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141444741246175853940000014154703758576047239_",
    gradientUnits: "userSpaceOnUse",
    x1: 754.1157,
    y1: 3099.9685,
    x2: 808.7586,
    y2: 3411.6357,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 -972.3445 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141444741246175853940000014154703758576047239_)"
    },
    d: "M1818.354,1220.414 c2.776-1.23,3.8-4.626,2.138-7.167c-5.057-7.725-14.537-23.485-17.561-37.283c0,0-11.346-7.268,28.88-16.895 c40.225-9.629,100.213-24.574,112.821-58.813c12.294-33.383-20.006-117.336-71.538-50.443c-1.96,2.545-5.801,2.6-7.758,0.054 c-8.448-10.996-30.658-33.817-61.493-19.981c-28.855,12.947-32.105,34.091-31.709,44.75c0.116,3.134-2.687,5.572-5.768,4.984 c-14.589-2.782-49.599-5.172-65.94,30.742c-13.46,29.583-4.711,46.328,3.255,54.518c2.583,2.653,1.451,7.023-2.089,8.106 c-9.587,2.935-21.969,11.065-20.73,33.529c1.714,31.055,36.435,28.318,46.32,26.904c1.621-0.232,3.252,0.324,4.349,1.537 c8.476,9.38,46.666,49.209,88,54.011c3.579,0.415,6.353-3.12,5.181-6.526l-17.888-51.998c-0.83-2.415,0.326-5.064,2.659-6.098 L1818.354,1220.414z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177449052578784310590000003202382438248624566_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.2742,
    y1: 3474.3608,
    x2: 687.5014,
    y2: 3280.5142,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 -972.3445 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177449052578784310590000003202382438248624566_)"
    },
    d: "M1825.544,1227.795 c0,0-44.939-30.834-48.223-4.868c-3.283,25.965,40.469,37.611,62.139,27.93L1825.544,1227.795z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176757652437720973210000015186314930377887136_",
    gradientUnits: "userSpaceOnUse",
    x1: 1585.6805,
    y1: 2644.5583,
    x2: 1443.5654,
    y2: 1623.9105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176757652437720973210000015186314930377887136_)"
    },
    d: "M1543.079,1758.377 c0,0-58.976,266.059-5.554,415.637c-65.492,30.366-53.394,24.642-53.394,24.642s-129.565-378.559-87.736-479.593 C1478.865,1710.314,1519.773,1732.473,1543.079,1758.377z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143592386587425424670000017838622373698704027_",
    gradientUnits: "userSpaceOnUse",
    x1: 1568.7574,
    y1: 2546.3767,
    x2: 1455.3494,
    y2: 1731.8973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143592386587425424670000017838622373698704027_)"
    },
    d: "M1537.526,2174.014 c0,0,33.749,43.68,31.049,61.078c-2.699,17.398-3.344,24.486-3.344,24.486s-16.958-11.598-15.89-26.419 c2.358,47.039,18.101,100.521,3.786,97.944c-14.315-2.578-88.417-70.881-71.663-143.694 C1519.481,2160.99,1530.138,2163.862,1537.526,2174.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028286756175562402040000000146495492090746044_",
    gradientUnits: "userSpaceOnUse",
    x1: 1827.1174,
    y1: 1968.2523,
    x2: 1898.4072,
    y2: 233.5354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028286756175562402040000000146495492090746044_)"
    },
    d: "M1828.153,1481.962l56.512,384.337 c1.047,7.123,0.045,14.44-2.86,20.867l-41.422,91.667c-3.977,8.802-15.094,8.74-18.995-0.105l-41.108-93.192 c-2.387-5.412-3.443-11.453-3.055-17.488l24.507-381.594L1828.153,1481.962z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175306492624642907790000000922661210520787102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1849.5546,
    y1: 1370.7952,
    x2: 1967.2048,
    y2: 1606.0951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175306492624642907790000000922661210520787102_)"
    },
    d: "M1827.494,1447.641l36.39,62.397 c3.508,7.6,17.021,8.102,21.437,0.797l44.981-99.51l-41.49-6.866L1827.494,1447.641z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031192490848051158620000007127195576596959105_",
    gradientUnits: "userSpaceOnUse",
    x1: 1844.8027,
    y1: 1332.4827,
    x2: 1637.3663,
    y2: 1638.9929
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031192490848051158620000007127195576596959105_)"
    },
    d: "M1740.148,1408.924l63.889,38.717 l-17.573,61.688c-3.299,8.462-18.704,9.079-23.146,0.927l-45.422-81.286L1740.148,1408.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025436471671581472860000007067956319524465819_",
    gradientUnits: "userSpaceOnUse",
    x1: 1766.103,
    y1: 1498.5441,
    x2: 2105.5786,
    y2: 1335.5958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025436471671581472860000007067956319524465819_)"
    },
    d: "M1799.152,1447.233l36.906-6.98 c1.679-0.318,3.179,1.097,2.961,2.792l-7.515,58.379c-0.137,1.062-0.931,1.921-1.98,2.14l-26.412,5.516 c-1.509,0.315-2.944-0.79-3.025-2.33l-2.979-56.915C1797.042,1448.578,1797.916,1447.466,1799.152,1447.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098191718538248493790000006756203578586096556_",
    gradientUnits: "userSpaceOnUse",
    x1: 2498.2839,
    y1: 1149.161,
    x2: 3003.6978,
    y2: 2392.3638
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098191718538248493790000006756203578586096556_)"
    },
    d: "M2797.739,1667.761h-422.432 c-2.638,0-4.776-2.138-4.776-4.776v-593.55c0-2.638,2.138-4.776,4.776-4.776h422.432c2.638,0,4.776,2.138,4.776,4.776v593.55 C2802.515,1665.623,2800.377,1667.761,2797.739,1667.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2768.351,1645.181h-364.145c-9.852,0-17.869-8.017-17.869-17.869v-525.017 c0-9.852,8.017-17.869,17.869-17.869h364.145c9.852,0,17.869,8.017,17.869,17.869v525.017 C2786.22,1637.164,2778.203,1645.181,2768.351,1645.181z M2404.206,1087.813c-7.985,0-14.482,6.497-14.482,14.482v525.017 c0,7.985,6.497,14.482,14.482,14.482h364.145c7.985,0,14.482-6.497,14.482-14.482v-525.017c0-7.985-6.497-14.482-14.482-14.482 H2404.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2759.942,1228.892h-343.588c-0.689,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.563,1.252,1.252v11.106 C2761.194,1228.328,2760.631,1228.892,2759.942,1228.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2759.942,1286.906h-343.588c-0.689,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.563,1.252,1.252v11.106 C2761.194,1286.343,2760.631,1286.906,2759.942,1286.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2759.942,1345.236h-343.588c-0.689,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.563,1.252,1.252v11.106 C2761.194,1344.673,2760.631,1345.236,2759.942,1345.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2759.942,1405.511h-343.588c-0.689,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.563,1.252,1.252v11.106 C2761.194,1404.947,2760.631,1405.511,2759.942,1405.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2758.317,1466.757h-343.588c-0.689,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.564,1.252,1.252v11.106 C2759.569,1466.194,2759.006,1466.757,2758.317,1466.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2757.998,1531.893H2414.41c-0.688,0-1.252-0.563-1.252-1.252v-11.106 c0-0.689,0.563-1.252,1.252-1.252h343.588c0.689,0,1.252,0.563,1.252,1.252v11.106 C2759.25,1531.329,2758.687,1531.893,2757.998,1531.893z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049179735068571768060000009381984722686993335_",
    gradientUnits: "userSpaceOnUse",
    x1: 2066.7197,
    y1: 908.5291,
    x2: 2237.1113,
    y2: 1096.2072,
    gradientTransform: "matrix(-0.9646 -0.2635 -0.2635 0.9646 4890.0137 662.8007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049179735068571768060000009381984722686993335_)"
    },
    d: "M2553.153,1040.162l10.974,50.451 c1.202,5.525-1.949,11.008-7.379,12.843l0,0c-5.763,1.946-12.147-0.856-14.551-6.387l-21.263-48.928 c-1.417-3.26-1.251-6.985,0.587-9.992c3.62-5.923,11.474-13.53,25.93-5.588 C2550.381,1034.171,2552.457,1036.962,2553.153,1040.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179608348704226487710000009114430698558345385_",
    gradientUnits: "userSpaceOnUse",
    x1: 2087.5239,
    y1: 889.6363,
    x2: 2257.9153,
    y2: 1077.3141,
    gradientTransform: "matrix(-0.9646 -0.2635 -0.2635 0.9646 4890.0137 662.8007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179608348704226487710000009114430698558345385_)"
    },
    d: "M2475.569,1060.026l8.959,41.187 c0.981,4.511-1.591,8.987-6.025,10.484l0,0c-4.705,1.589-9.917-0.699-11.879-5.215l-17.359-39.944 c-1.157-2.662-1.021-5.703,0.479-8.157c2.956-4.836,9.367-11.046,21.169-4.562 C2473.306,1055.136,2475,1057.414,2475.569,1060.026z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113341346631547170700000005056023638262395821_",
    gradientUnits: "userSpaceOnUse",
    x1: 2081.0647,
    y1: 895.5022,
    x2: 2251.4561,
    y2: 1083.1799,
    gradientTransform: "matrix(-0.9646 -0.2635 -0.2635 0.9646 4890.0137 662.8007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113341346631547170700000005056023638262395821_)"
    },
    d: "M2497.348,1054.22l10.176,46.782 c1.115,5.123-1.807,10.208-6.843,11.908l0,0c-5.344,1.805-11.264-0.794-13.493-5.923l-19.717-45.37 c-1.314-3.023-1.16-6.477,0.544-9.265c3.357-5.493,10.64-12.546,24.044-5.182 C2494.778,1048.665,2496.702,1051.253,2497.348,1054.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093139928315843336750000016020564168230457532_",
    gradientUnits: "userSpaceOnUse",
    x1: 2073.1262,
    y1: 902.7109,
    x2: 2243.5178,
    y2: 1090.3889,
    gradientTransform: "matrix(-0.9646 -0.2635 -0.2635 0.9646 4890.0137 662.8007)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093139928315843336750000016020564168230457532_)"
    },
    d: "M2525.338,1045.551l11.323,55.159 c1.24,6.041-2.169,12.07-7.985,14.121l0,0c-6.171,2.177-12.969-0.841-15.493-6.879l-22.326-53.409 c-1.488-3.559-1.281-7.639,0.706-10.946c3.914-6.515,12.364-14.907,27.743-6.324 C2522.425,1039.013,2524.62,1042.053,2525.338,1045.551z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.63,
      fill: "#FFFFFF"
    },
    d: "M2735.606,1172.969h-298.45c-2.064,0-3.737-1.673-3.737-3.737v-33.641 c0-2.064,1.673-3.737,3.737-3.737h298.45c2.064,0,3.737,1.673,3.737,3.737v33.641 C2739.343,1171.296,2737.67,1172.969,2735.606,1172.969z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142158088445542890460000006774804325005280139_",
    gradientUnits: "userSpaceOnUse",
    x1: 2107.2664,
    y1: 2392.5151,
    x2: 2235.0796,
    y2: 2244.1606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000142158088445542890460000006774804325005280139_)"
    },
    cx: 2237.661,
    cy: 2241.164,
    r: 95.289
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110447961460922262190000009903477987351863456_",
    gradientUnits: "userSpaceOnUse",
    x1: 2307.3022,
    y1: 2135.9563,
    x2: 1929.3553,
    y2: 2706.9265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000110447961460922262190000009903477987351863456_)"
    },
    cx: 2237.661,
    cy: 2241.164,
    r: 92.121
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2161.696,2206.475c-0.541,0-1.092-0.122-1.609-0.384c-1.765-0.889-2.472-3.042-1.581-4.806 c15.172-30.06,45.502-48.735,79.154-48.735c5.376,0,10.752,0.484,15.982,1.436c1.944,0.355,3.234,2.217,2.879,4.162 c-0.353,1.944-2.21,3.228-4.162,2.879c-4.808-0.877-9.754-1.321-14.7-1.321c-30.936,0-58.818,17.169-72.767,44.804 C2164.265,2205.757,2163.005,2206.475,2161.696,2206.475z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4472 -0.8944 0.8944 0.4472 -768.2958 3243.2134)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2239.668,
    cy: 2243.171,
    rx: 77.969,
    ry: 77.969
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018207973012341215750000014782654209438963865_",
    gradientUnits: "userSpaceOnUse",
    x1: 2296.0278,
    y1: 2152.3167,
    x2: 2094.7791,
    y2: 2490.1797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018207973012341215750000014782654209438963865_)"
    },
    d: "M2232.017,2301.135v-8.482 c-8.843-0.354-17.589-2.441-23.801-5.161c-2.219-0.971-3.349-3.461-2.712-5.797l2.155-7.902 c0.791-2.899,3.943-4.397,6.714-3.236c6.163,2.583,13.771,4.627,21.976,4.627c8.517,0,14.869-2.887,14.869-8.807 c0-5.341-4.908-8.516-16.746-11.692c-16.89-4.62-29.017-11.982-29.017-26.851c0-13.426,9.817-23.676,26.852-26.418v-8.484 c0-2.729,2.212-4.942,4.942-4.942h4.984c2.729,0,4.942,2.213,4.942,4.942v7.617c8.183,0.327,14.139,1.727,18.866,3.387 c2.422,0.851,3.745,3.46,3.073,5.938l-1.981,7.307c-0.764,2.818-3.776,4.361-6.507,3.329c-4.352-1.646-10.505-3.36-18.503-3.36 c-10.105,0-12.992,4.187-12.992,7.94c0,4.619,6.063,7.795,19.199,11.838c18.767,5.63,26.562,13.425,26.562,27.428 c0,12.848-9.528,24.397-28.006,27.284v9.493c0,2.73-2.213,4.942-4.942,4.942h-4.984 C2234.23,2306.077,2232.017,2303.864,2232.017,2301.135z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138552796971886372830000018210413950611674801_",
    gradientUnits: "userSpaceOnUse",
    x1: 2281.9097,
    y1: 2391.6379,
    x2: 2504.4102,
    y2: 2133.3787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000138552796971886372830000018210413950611674801_)"
    },
    cx: 2508.905,
    cy: 2128.162,
    r: 165.883
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161627699825082364110000017300561524595120545_",
    gradientUnits: "userSpaceOnUse",
    x1: 2630.1377,
    y1: 1945.0135,
    x2: 1972.1973,
    y2: 2938.9739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000161627699825082364110000017300561524595120545_)"
    },
    cx: 2508.905,
    cy: 2128.162,
    r: 160.367
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2376.665,2065.124c-0.542,0-1.092-0.122-1.609-0.384c-1.765-0.889-2.472-3.042-1.581-4.806 c25.962-51.435,77.856-83.385,135.43-83.385c9.183,0,18.385,0.828,27.348,2.46c1.944,0.354,3.234,2.217,2.879,4.161 c-0.353,1.943-2.21,3.222-4.162,2.879c-8.542-1.556-17.31-2.344-26.065-2.344c-54.859,0-104.304,30.445-129.042,79.455 C2379.233,2064.406,2377.973,2065.124,2376.665,2065.124z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -771.4437 2400.8818)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2512.399,
    cy: 2131.656,
    rx: 135.731,
    ry: 135.731
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111875405210600041860000006481916042749312950_",
    gradientUnits: "userSpaceOnUse",
    x1: 2610.5105,
    y1: 1973.4937,
    x2: 2260.1709,
    y2: 2561.6558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111875405210600041860000006481916042749312950_)"
    },
    d: "M2499.079,2232.56v-14.767 c-15.394-0.616-30.62-4.25-41.435-8.983c-3.862-1.69-5.83-6.024-4.721-10.091l3.751-13.755 c1.376-5.046,6.864-7.656,11.687-5.634c10.727,4.497,23.973,8.055,38.256,8.055c14.827,0,25.885-5.027,25.885-15.331 c0-9.298-8.544-14.826-29.152-20.354c-29.402-8.042-50.513-20.859-50.513-46.744c0-23.373,17.09-41.215,46.743-45.989v-14.768 c0-4.752,3.853-8.604,8.604-8.604h8.676c4.752,0,8.604,3.852,8.604,8.604v13.259c14.244,0.57,24.613,3.006,32.842,5.897 c4.216,1.481,6.52,6.022,5.35,10.335l-3.45,12.721c-1.33,4.906-6.573,7.592-11.327,5.795 c-7.576-2.865-18.288-5.848-32.211-5.848c-17.592,0-22.616,7.287-22.616,13.822c0,8.041,10.554,13.57,33.423,20.608 c32.671,9.8,46.24,23.371,46.24,47.748c0,22.366-16.586,42.471-48.753,47.498v16.526c0,4.752-3.852,8.604-8.604,8.604h-8.677 C2502.932,2241.164,2499.079,2237.312,2499.079,2232.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153689460503114281630000017352250467758864010_",
    gradientUnits: "userSpaceOnUse",
    x1: 2389.7324,
    y1: 2769.783,
    x2: 2618.6829,
    y2: 2504.0371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000153689460503114281630000017352250467758864010_)"
    },
    cx: 2623.308,
    cy: 2498.669,
    r: 170.691
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024688168347497799590000012622288771722645384_",
    gradientUnits: "userSpaceOnUse",
    x1: 2748.0549,
    y1: 2310.2117,
    x2: 2071.0422,
    y2: 3332.9846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000024688168347497799590000012622288771722645384_)"
    },
    cx: 2623.308,
    cy: 2498.669,
    r: 165.015
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2487.234,2433.7c-0.542,0-1.092-0.122-1.609-0.384c-1.765-0.89-2.472-3.042-1.581-4.806 c26.698-52.888,80.059-85.744,139.263-85.744c9.448,0,18.909,0.851,28.123,2.528c1.945,0.354,3.232,2.217,2.879,4.162 c-0.353,1.942-2.207,3.225-4.162,2.879c-8.791-1.6-17.822-2.413-26.841-2.413c-56.488,0-107.401,31.349-132.876,81.813 C2489.802,2432.981,2488.542,2433.7,2487.234,2433.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -999.9664 2590.3972)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2626.903,
    cy: 2502.265,
    rx: 139.665,
    ry: 139.665
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070801635233385086140000004150532674004972438_",
    gradientUnits: "userSpaceOnUse",
    x1: 2727.8589,
    y1: 2339.5173,
    x2: 2367.3633,
    y2: 2944.7297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070801635233385086140000004150532674004972438_)"
    },
    d: "M2613.197,2606.094v-15.195 c-15.84-0.634-31.508-4.373-42.635-9.244c-3.973-1.74-5.999-6.199-4.858-10.384l3.86-14.153 c1.416-5.192,7.063-7.878,12.026-5.797c11.039,4.628,24.668,8.289,39.365,8.289c15.257,0,26.635-5.172,26.635-15.775 c0-9.567-8.792-15.256-29.996-20.944c-30.255-8.275-51.978-21.463-51.978-48.098c0-24.05,17.585-42.41,48.099-47.322v-15.197 c0-4.89,3.964-8.854,8.854-8.854h8.927c4.89,0,8.853,3.964,8.853,8.854v13.644c14.657,0.586,25.327,3.093,33.794,6.068 c4.338,1.524,6.709,6.197,5.505,10.635l-3.55,13.089c-1.369,5.048-6.764,7.813-11.655,5.963 c-7.796-2.948-18.818-6.018-33.144-6.018c-18.102,0-23.273,7.499-23.273,14.222c0,8.275,10.861,13.963,34.392,21.205 c33.617,10.085,47.58,24.049,47.58,49.132c0,23.014-17.066,43.702-50.166,48.875v17.005c0,4.889-3.964,8.854-8.854,8.854 h-8.929C2617.161,2614.948,2613.197,2610.983,2613.197,2606.094z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089566002982394256530000016478703886597088957_",
    gradientUnits: "userSpaceOnUse",
    x1: 2671.1426,
    y1: 2464.7974,
    x2: 2838.8928,
    y2: 2270.0876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000089566002982394256530000016478703886597088957_)"
    },
    cx: 2842.281,
    cy: 2266.155,
    r: 125.064
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032606335255525964610000000950662374369759878_",
    gradientUnits: "userSpaceOnUse",
    x1: 2933.6826,
    y1: 2128.0735,
    x2: 2437.6406,
    y2: 2877.4512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000032606335255525964610000000950662374369759878_)"
    },
    cx: 2842.281,
    cy: 2266.155,
    r: 120.905
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2742.581,2219.509c-0.542,0-1.092-0.123-1.609-0.384c-1.765-0.89-2.472-3.042-1.581-4.806 c19.723-39.076,59.148-63.35,102.891-63.35c6.985,0,13.975,0.629,20.778,1.87c1.943,0.354,3.232,2.219,2.877,4.162 c-0.356,1.946-2.203,3.234-4.163,2.879c-6.379-1.164-12.937-1.754-19.492-1.754c-41.026,0-78.003,22.768-96.503,59.419 C2745.15,2218.79,2743.89,2219.509,2742.581,2219.509z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -771.0196 2676.1721)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 2844.916,
    cy: 2268.789,
    rx: 102.331,
    ry: 102.332
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042722453595234122160000002206056821359016607_",
    gradientUnits: "userSpaceOnUse",
    x1: 2918.8853,
    y1: 2149.5454,
    x2: 2654.7534,
    y2: 2592.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042722453595234122160000002206056821359016607_)"
    },
    d: "M2834.874,2344.864v-11.133 c-11.606-0.465-23.086-3.204-31.239-6.773c-2.911-1.274-4.395-4.542-3.559-7.608l2.828-10.37 c1.038-3.804,5.175-5.772,8.812-4.248c8.088,3.391,18.074,6.073,28.843,6.073c11.178,0,19.515-3.79,19.515-11.559 c0-7.01-6.442-11.178-21.979-15.345c-22.167-6.063-38.083-15.726-38.083-35.241c0-17.621,12.884-31.073,35.241-34.672v-11.135 c0-3.583,2.904-6.487,6.487-6.487h6.541c3.583,0,6.487,2.905,6.487,6.487v9.997c10.74,0.43,18.557,2.266,24.76,4.447 c3.178,1.117,4.915,4.541,4.034,7.792l-2.601,9.591c-1.003,3.698-4.955,5.724-8.54,4.369 c-5.712-2.16-13.788-4.409-24.285-4.409c-13.263,0-17.052,5.494-17.052,10.42c0,6.063,7.957,10.231,25.199,15.536 c24.631,7.389,34.862,17.62,34.862,35.999c0,16.863-12.504,32.02-36.756,35.81v12.459c0,3.583-2.904,6.487-6.487,6.487h-6.542 C2837.778,2351.351,2834.874,2348.446,2834.874,2344.864z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2072.26,
    cy: 736.999,
    r: 223.748
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087377190911845000330000001644090459159835020_",
    gradientUnits: "userSpaceOnUse",
    x1: 1964.525,
    y1: 525.7139,
    x2: 2297.4868,
    y2: 1178.7065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000087377190911845000330000001644090459159835020_)"
    },
    cx: 2072.26,
    cy: 736.999,
    r: 198.755
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2184.072,683.496h-58.31v-58.31c0-10.401-8.432-18.833-18.833-18.833h-69.339 c-10.401,0-18.833,8.432-18.833,18.833v58.31h-58.31c-10.403,0-18.834,8.432-18.834,18.834v69.339 c0,10.401,8.431,18.833,18.834,18.833h58.31v58.31c0,10.401,8.432,18.833,18.833,18.833h69.339 c10.402,0,18.833-8.432,18.833-18.833v-58.31h58.31c10.403,0,18.834-8.432,18.834-18.833V702.33 C2202.906,691.928,2194.475,683.496,2184.072,683.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -258.7921 1185.0603)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1301.098,
    cy: 904.92,
    rx: 245.358,
    ry: 245.358
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107585970022416940410000010899226674721658502_",
    gradientUnits: "userSpaceOnUse",
    x1: 1144.0044,
    y1: 620.124,
    x2: 1693.4548,
    y2: 1616.2241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000107585970022416940410000010899226674721658502_)"
    },
    cx: 1301.098,
    cy: 904.92,
    r: 217.951
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1429.682,863.393l-128.584-98.771l-128.584,98.771c-6.24,4.794-2.851,14.773,5.018,14.773h18.181 c-0.214,1.054-0.328,2.145-0.328,3.263v147.476c0,9.01,7.304,16.313,16.314,16.313h178.798c9.01,0,16.313-7.304,16.313-16.313 V881.428c0-1.118-0.113-2.208-0.328-3.263h18.181C1432.533,878.166,1435.922,868.187,1429.682,863.393z M1342.889,987.851 h-83.582v-83.583h83.582V987.851z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -799.793 1058.0554)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 877.289,
    cy: 1494.463,
    rx: 240.371,
    ry: 240.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018235366452928968230000000036348093498700427_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.563,
    y1: 1702.5389,
    x2: 1125.9404,
    y2: 990.8116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000018235366452928968230000000036348093498700427_)"
    },
    cx: 877.289,
    cy: 1494.463,
    r: 213.521
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M784.14,1526.45c0-9.432-7.646-17.077-17.077-17.077h-6.485 c-9.431,0-17.077,7.646-17.077,17.077v43.738c0,9.431,7.646,17.077,17.077,17.077h6.485c9.431,0,17.077-7.646,17.077-17.077 V1526.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1014.43,1526.493c0-17.406-31.456-17.12-16.964-17.12h-7.712 c-9.431,0-15.964,7.689-15.964,17.12v43.598c0,9.431,6.532,17.174,15.964,17.174h7.712c9.432,0,16.964-7.743,16.964-17.174 V1526.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M761.955,1442.124c-0.512-0.113-1.521-0.567-1.521-1.091v-3.509c0-3.382-1.26-6.475-4.279-7.997 c-3.896-1.964-8.154-2.032-12.107-0.186l-7.843,3.397c-3.465,1.619-6.251,5.098-6.251,8.922v2.676 c0,4.925,4.371,9.094,9.251,9.758l30.27,4.071l3.558-13.62L761.955,1442.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M996.124,1442.124c0.512-0.113,1.372-0.567,1.372-1.091v-3.509c0-3.382,1.409-6.475,4.428-7.997 c3.896-1.964,8.229-2.032,12.181-0.186l7.731,3.397c3.465,1.619,6.139,5.098,6.139,8.922v2.676 c0,4.925-4.222,9.094-9.102,9.758l-30.196,4.071l-3.596-13.62L996.124,1442.124z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1017.476,1472.236c-4.329-14.613-26.698-27.674-26.698-27.674s-18.761-57.107-38.965-57.107 c-16.223,0-55.18,0-69.903,0c0,0-2.16,0-5.773,0c-14.739,0-53.765,0-69.992,0c-20.204,0-38.965,57.107-38.965,57.107 s-22.369,13.287-26.698,27.901c-3.165,10.683,3.697,52.555,7.616,73.759c1.382,7.475,8.436,13.951,16.674,13.951h111.365h5.773 h111.276c8.237,0,15.292-6.589,16.673-14.064C1013.779,1524.904,1020.641,1482.92,1017.476,1472.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1013.133,1534.565c-1.243-1.44-3.139-1.486-5.145-1.486H750.345 c-1.994,0-3.879,0.035-5.123,1.461c-1.244,1.425-1.711,2.894-1.269,4.672l4.216,18.324c0.678,2.73,3.331,6.023,6.392,6.023h249 c3.034,0,5.672-3.46,6.376-6.159l4.427-17.348C1014.83,1538.267,1014.376,1536.005,1013.133,1534.565z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005265875866276333340000017311222880244587436_",
    gradientUnits: "userSpaceOnUse",
    x1: 696.6051,
    y1: 1664.051,
    x2: 1047.9829,
    y2: 952.3229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005265875866276333340000017311222880244587436_)"
    },
    d: "M808.501,1507.292 c0,0-6.494-19.482-14.672-21.166c-8.178-1.684-42.813-8.899-43.535-2.886c-0.721,6.013-7.697,26.698,12.988,28.622 C783.968,1513.786,811.833,1515.369,808.501,1507.292z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175311298146969681660000016958477500282383026_",
    gradientUnits: "userSpaceOnUse",
    x1: 860.2452,
    y1: 1744.84,
    x2: 1211.6239,
    y2: 1033.1101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175311298146969681660000016958477500282383026_)"
    },
    d: "M949.457,1507.292 c0,0,6.494-19.482,14.672-21.166c8.178-1.684,42.813-8.899,43.534-2.886c0.722,6.013,7.697,26.698-12.988,28.622 C973.99,1513.786,946.125,1515.369,949.457,1507.292z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121279873382724720340000015112524076894236059_",
    gradientUnits: "userSpaceOnUse",
    x1: 775.0687,
    y1: 1703.8689,
    x2: 1127.1765,
    y2: 990.662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121279873382724720340000015112524076894236059_)"
    },
    d: "M944.793,1490.693 c-0.672-1.035-1.822-1.64-3.056-1.64H816.221c-1.278,0-2.463,0.65-3.122,1.745c-0.659,1.095-0.696,2.446-0.097,3.575 l7.062,13.529c2.62,4.941,7.756,8.244,13.349,8.244h92.224c5.965,0,11.371-3.726,13.8-9.174l5.625-12.714 C945.567,1493.131,945.465,1491.728,944.793,1490.693z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039125252964755696820000005017968850636384425_",
    gradientUnits: "userSpaceOnUse",
    x1: 757.0654,
    y1: 1692.9695,
    x2: 1108.1514,
    y2: 981.8323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039125252964755696820000005017968850636384425_)"
    },
    d: "M978.971,1449.293 c-0.815,1.241-2.201,2.507-3.694,2.507H782.676c-1.508,0-2.915-1.287-3.723-2.565c-0.808-1.277-0.909-3.137-0.26-4.508 c4.373-9.214,12.577-26.401,17.173-35.947c0.209-0.433,0.44-1.26,0.7-1.656c2.222-3.528,6.126-6.123,10.362-6.123h145.648 c4.279,0,8.197,2.573,10.412,6.131c0.31,0.505,0.592,1.207,0.83,1.756l15.499,35.883 C979.917,1446.134,979.787,1448.045,978.971,1449.293z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceImage);
export default __webpack_public_path__ + "static/media/insuranceImage.771238a8aec28d8330337cf6bced28ad.svg";
export { ForwardRef as ReactComponent };